import { Persona } from "@fluentui/react-components";

/**
 * @param {object} props.details        { displayName }
 * @param {string} [props.secondaryText] ligne secondaire — l'adresse du compte sur la recherche
 *                                       de resource account : deux comptes peuvent porter le
 *                                       même nom d'affichage, c'est elle qui permet de trancher.
 */
const Person = (props) => {
    return (
        <Persona
            size="small"
            textAlignment="center"
            name={props.details && props.details.displayName ? props.details.displayName : "Kevin Sturgis"}
            secondaryText={props.secondaryText || undefined}
            avatar={
                props.avatar?.image?.src
                    ? {
                        image: {
                            src: props.avatar.image.src,
                        },
                    }
                    : {
                        color: "colorful",
                    }
            }
        />
    );
};

export default Person;
